import React from "react";
import { Typography, Box, Button } from "@material-ui/core";
import styles from "../styles";

function ADANotificationText({ displayAccommodationTypes }) {
  const classes = styles();

  return (
    <>
      <Box style={{ marginBottom: "24px" }}>
        <Typography>
          This student is approved for the following accommodation(s) under University policy.
        </Typography>
      </Box>

      <Box style={{ marginBottom: "24px" }}>
        <Typography component="h3" className={classes.subHeadingText}>
          Approved Accommodations:
        </Typography>
      </Box>

      <Box style={{ marginBottom: "24px" }}>
        <Typography className={classes.accomText}>
          {displayAccommodationTypes.length > 0 &&
            displayAccommodationTypes.map(
              (accommodation, index) => (
                <React.Fragment key={index}>
                  <Typography display="inline">
                    {accommodation && accommodation !== "null" && `${accommodation}${index < displayAccommodationTypes.length - 1 ? `; ` : ''}`}
                  </Typography>
                </React.Fragment>
              )
            )}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`Faculty may access information about accommodations through the `}
          <Button
            href={process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Accommodation Dictionary`}
          </Button>
          {` available on the Faculty Resource Center. Students will access the `}
          <Button
            href={process.env.REACT_APP_STUDENT_ACCOMMODATION_DICTIONARY_URL}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Student Accommodation Dictionary`}
          </Button>
          {` with the same information in the My
          Phoenix Help Topics.`}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`The `}
          <Button
            href={`${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#Faculty-Responsibilities-ADA`}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Faculty Responsibilities – ADA`}
          </Button>
          {` outlines your responsibilities. Please review in the Resource section of the Accommodation Dictionary.`}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`Please also review `}
          <Button
            href={`${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#Setting-Up-Accommodations-In-Blackboard`}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Setting Up Accommodations in Blackboard`}
          </Button>
          {`, which will help you designate the students who receive accommodations. Additional resources for managing accommodated students in Blackboard are also provided.`}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`All information pertaining to the student's accommodations must remain confidential. The reason the student qualifies for accommodations is not disclosed to faculty and is not information faculty needs to know to implement accommodations in a course.`}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`If you have any questions regarding this information, please do not hesitate to contact us for more information. Have a great day and thank you for your continued efforts to assist our students.`}
        </Typography>
      </Box>

      <Box className={classes.thankyouContainer}>
        <Typography> Thank you, </Typography>
        <Typography className={classes.justBold}>
          Your Student Accommodations Team
        </Typography>
      </Box>
    </>
  );
}

export default ADANotificationText;
